import { useState, useEffect } from "react";
import { X, Tag } from "lucide-react";
import api from "@/lib/api";

export const PromoBanner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/banners/active").then(res => {
      if (res.data) setBanner(res.data);
    }).catch(() => {});
  }, []);

  if (!banner || dismissed) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[70] py-2.5 px-6 flex items-center justify-center gap-3 text-center"
      style={{ backgroundColor: banner.bg_color || "#0F172A", color: banner.text_color || "#C5A059" }}
      data-testid="promo-banner"
    >
      <Tag className="w-3.5 h-3.5 shrink-0" />
      <p className="font-manrope text-xs sm:text-sm font-medium">
        {banner.title}
        {banner.description && <span className="font-normal opacity-80 ml-1">{banner.description}</span>}
        {banner.discount_code && (
          <span className="ml-2 px-2 py-0.5 bg-white/10 font-mono text-xs tracking-wider">
            {banner.discount_code}
          </span>
        )}
      </p>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-4 opacity-50 hover:opacity-100 transition-opacity duration-200"
        data-testid="promo-banner-close"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
